import { Container, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function AppHeader({ action }) {
  const { t } = useTranslation()

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{ borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}
    >
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ minHeight: 56 }}>
          <Typography variant="subtitle1" fontWeight={700}>
            CLML - {t('appName')}
          </Typography>
          {action}
        </Stack>
      </Container>
    </Container>
  )
}
